import { BadgeTypeEnum } from '@getvim/atomic-ui';

export type BadgeProps = {
  type: BadgeTypeEnum;
  title: string;
  value?: string;
  comment?: string;
  description: string;
};

export const acceptingNewPatientsBadge = (
  isLongTooltipText: boolean,
): Omit<BadgeProps, 'value' | 'comment'> => {
  return isLongTooltipText
    ? {
        type: BadgeTypeEnum.acceptingNewPatients,
        title: 'Accepting All Patients',
        description:
          "Accepting All Patients. Includes New and Existing Patients. We recommend you contact the provider's office to confirm. The provider might be accepting existing patients only or no patients at all at this time and this update is not reflected here yet.",
      }
    : {
        type: BadgeTypeEnum.acceptingNewPatients,
        title: 'Accepting new patients',
        description: 'Accepting new patients',
      };
};
export const notAcceptingNewPatientsBadge = (
  isLongTooltipText: boolean,
): Omit<BadgeProps, 'value' | 'comment'> => {
  return isLongTooltipText
    ? {
        type: BadgeTypeEnum.notAcceptingNewPatients,
        title: 'Not Accepting New Patients',
        description:
          "Not Accepting New Patients. We recommend you contact the provider's office to confirm. The provider might be accepting new or existing patients at this time and this update is not reflected here yet.",
      }
    : {
        type: BadgeTypeEnum.notAcceptingNewPatients,
        title: 'Not accepting new patients',
        description: 'Not accepting new patients',
      };
};

export const caterpillarNetworkBadge = (): Omit<BadgeProps, 'value' | 'comment'> => {
  return {
    type: BadgeTypeEnum.caterpillarNetwork,
    title: 'Caterpillar\nNetwork\nProvider',
    description: 'Caterpillar Network Providers',
  };
};

export const scoreBadge = (score: string): BadgeProps => {
  return {
    type: BadgeTypeEnum.score,
    title: 'Score: ',
    value: score,
    comment: '/100',
    description: '',
  };
};

export const patientRatingBadge = (rating: string): BadgeProps => {
  return {
    type: BadgeTypeEnum.patientRating,
    title: 'Patient rating: ',
    value: rating,
    comment: '/5',
    description: '',
  };
};

export const networkStatusBadge = (isInNetwork: boolean): Omit<BadgeProps, 'comment'> => {
  return {
    type: BadgeTypeEnum.networkStatus,
    title: 'Network status: ',
    value: isInNetwork ? 'In network' : 'Out of network',
    description: '',
  };
};
